import { createApiRequest } from "../common";
import { ListOrgMembersRequestContent as ListOrgMembersRequestContentv2, ListOrgMembersResponseContent as ListOrgMembersResponseContentv2 } from '@equaliq/api-model-v2';
import { ListOrgMembersRequestContent, ListOrgMembersResponseContent } from '@equaliq/api-model';

export const listOrgMembersApi = async (request: ListOrgMembersRequestContent): Promise<ListOrgMembersResponseContent> => {
  const apiRequest = createApiRequest<ListOrgMembersResponseContent>('post', '/orgs/members/list');
  return apiRequest(request);
};

export const listOrgMembersApiv2 = async (request: ListOrgMembersRequestContentv2): Promise<ListOrgMembersResponseContentv2> => {
  const apiRequest = createApiRequest<ListOrgMembersResponseContentv2>('post', '/orgs/members/list');
  return apiRequest(request);
};